import { render, staticRenderFns } from "./eod-custom-fields-item.vue?vue&type=template&id=28b12854"
import script from "./eod-custom-fields-item.vue?vue&type=script&lang=js"
export * from "./eod-custom-fields-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports